<template>
  <article class="event">
    <figure class="figure">
      <img class="eventImage" :src="image" alt="" />
      <figcaption class="eventCaption">
        <slot name="caption" />
      </figcaption>
    </figure>
    <div class="content">
      <p class="eventDescription">
        <slot name="description" />
      </p>
      <div class="contentInfo">
        <slot name="info" />
        <button @click="onActionClick" class="action">
          {{ eventsData.learnMoreButtonName }}
        </button>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "EventCard",
  props: ["image"],
  computed: {
    eventsData() {
      return this.$t("events");
    }
  },
  methods: {
    onActionClick() {
      this.$emit("actionClick");
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/vars";
@import "src/assets/style/media";

.event {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  grid-gap: 12px;
}

.eventCaption {
  position: relative;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 34px;
  line-height: 1.1;
  color: $white;
  text-transform: uppercase;
}

.eventCaptionText {
  display: block;
}

.eventDescription {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  color: $dark;
  font-size: 20px;
  line-height: 1.4;
  margin: 0;
}

.figure {
  display: flex;
  align-items: flex-end;
  padding: 20px 32px;
  width: 100%;
  height: 100%;
  min-height: 380px;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}

.eventImage {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  border-radius: 20px;
}

.content {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  padding-left: 32px;

  @include mobileMedia {
    padding-left: 8px;
  }
}

.contentInfo {
  display: flex;
  grid-gap: 8px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 1.3;
  color: $grey;

  @include mobileMedia {
    flex-direction: column;
    align-items: flex-start;
  }
}

.action {
  cursor: pointer;
  color: $activeColor;
}
</style>
